import type {
    AttachGenerate,
    AttachReset,
    AttachScramble,
    AttachValidate,
    GenerateHookFn,
    ResetHookFn,
    ScrambleHookFn,
    ValidateHookFn,
} from "./controller";

export interface BaseProps<T> {
    label?: string;
    mode?: "create" | "update" | "static" | "remove";
    value?: T;
    required?: boolean;
    disabled?: boolean;
    guideText?: string;
    clearable?: boolean;
    deletable?: boolean;
    embedMode?: "embed" | "inline";
    attachReset?: (resetHook: ResetHookFn) => AttachReset<T | undefined>;
    attachRemove?: () => Promise<boolean>;
    attachUpdate?: (data: T) => Promise<boolean>;
    attachGenerate?: (generateHook: GenerateHookFn) => AttachGenerate<T>;
    attachScramble?: (scrambleHook: ScrambleHookFn) => AttachScramble<T>;
    attachValidate?: <V>(validateHook: ValidateHookFn) => AttachValidate<V>;
}

export function defaultProps<T>(): Partial<BaseProps<T>> {
    return {
        mode: "create",
        clearable: true,
        deletable: true,
    };
}
